<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
  <ol class="carousel-indicators">
    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
  </ol>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img class="d-block w-100" src="assets/img/banner2.jpg" alt="First slide">
      <div class="carousel-caption  d-md-block">
        <h5 class="font-weight-bold">El Huarache Ssabrosson</h5>
        <p>Con mas de 7 años de experiencia </p>
      </div>
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="assets/img/bannerG.jpg" alt="Second slide">
      <div class="carousel-caption  d-md-block">
        <h5 class="font-weight-bold">Galletas Caseras Vargas</h5>
        <p>Hechas artesanalmente con amor</p>
      </div>
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="assets/img/clasicosB.jpg" alt="Third slide">
      <div class="carousel-caption  d-md-block">
        <h5 class="font-weight-bold">Cocina Clasicos</h5>
        <p>Proximamente</p>
      </div>
    </div>
  </div>


  <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>


<div id="titleCaja">
  <br>

  <h1 id="title" class="font-weight-light text-center" style="font-size:2rem; color:white;">Tiendas</h1>
</div>

<div class="container text-center">


  <div class="row">




    <div class="col">
      <div class="card" style="width: 18rem;">
       <a href="/home/huarache"> <img class="card-img-top" src="assets/img/navidad1.jpg" alt="Card image cap"> </a> 
       
        <div class="card-body" id="card1">
          <!-- <br><br> -->
          <h5 class="card-title">El Huarache Ssabrosson </h5>
          <p class="card-text">Calle Gardenias #252 Col. Tepeyac</p>
          <p class="card-text">Contamos con servicio a domicilio</p>
          <a href="/home/huarache" class="btn btn-dark btn-block" >Visitar</a>
          <!--   routerLink -->
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card" style="width: 18rem;">
       <a href="/home/galletas"><img class="card-img-top" src="assets/img/Gallet.jpg" alt="Card image cap"></a> 
        <div class="card-body">
          <h5 class="card-title">Galletas Caseras Vargas</h5>
          <p class="card-text">50 piezas por caja</p>
          <p class="card-text">Solo servicio a domicilio</p>
          <a href="/home/galletas" class="btn btn-dark btn-block" >Visitar</a>

        </div>
      </div>
    </div>

    <div class="col">
      <div class="card" style="width: 18rem;">
        <img class="card-img-top" src="assets/img/clasicos50.jpg" alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">Cocina clasicos</h5>
          <p class="card-text">3 Norte, Col. Centro</p>
          <p class="card-text">Contamos con servicio a domicilio</p>
          <a href="#" class="btn btn-dark btn-block disabled">Proximamente</a>

        </div>
      </div>
    </div>




    

  </div>
</div>


